import React from 'react';

import Money from 'brandComponents/Money';

import {IMultiCurrencyProductPriceProps} from './IMultiCurrencyProductPrice';

const MultiCurrencyProductPrice = ({
	pricesArray,
	priceType,
	showLocalizedPrices = false,
	currencyConfig,
}: IMultiCurrencyProductPriceProps) => {
	const currencyRoundUpPriceFactor = currencyConfig.roundUpPriceFactor;
	const prices: React.ReactNode[] = pricesArray.map<React.ReactNode>(
		(price) => {
			if (currencyRoundUpPriceFactor && (price.currency in currencyRoundUpPriceFactor)) {
				let priceRoundValue = currencyRoundUpPriceFactor[price.currency];
				price.value = Math.round(Math.floor(price.value / priceRoundValue)) * priceRoundValue;
			}

			return (
				<Money
					key={[price.value, price.currency, priceType].join('-')}
					classNames={`product-price__${priceType}`}
					value={price.value}
					currency={price.currency}
					showLocalizedPrices={showLocalizedPrices}
				/>
			);
		}
	);

	if (prices.length) {
		return prices.reduce((prev, curr, index) => {
			const delimiter = index === 0 ? '' : currencyConfig.delimiter || '';

			return [prev, delimiter, curr];
		}, null);
	}

	return null;
};

export default MultiCurrencyProductPrice;
